import { deleteData, getData, postData } from '~/utils/service';
import {
  ActivationPreview,
  BillingHistoryRow,
  BillingPortalMode,
  BillingSchedule,
  BillingSummary,
  EmployerCredit,
  ListingActivationPreview,
  ListingFeeKind,
  PortalSessionResponse,
} from './types';

export const getBillingSummary = () => getData<BillingSummary>('billingSummary');

export const getBillingHistory = () => getData<BillingHistoryRow[]>('billingHistory');

export const getBillingSchedules = () => getData<BillingSchedule[]>('billingSchedules');

export const createBillingPortalSession = (
  returnPath?: string,
  mode: BillingPortalMode = 'replace'
) =>
  postData<PortalSessionResponse>('billingPortalSession', {
    data: { ...(returnPath ? { returnPath } : {}), mode },
  });

export const getActivationPreview = (responseId: number, signal?: AbortSignal) =>
  getData<ActivationPreview>('billingActivationPreview', {
    pathParams: { responseId: responseId.toString() },
    signal,
  });

export const getListingActivationPreview = (
  listingType: ListingFeeKind,
  listingId: number,
  signal?: AbortSignal
) =>
  getData<ListingActivationPreview>('billingListingActivationPreview', {
    pathParams: { listingType, listingId: listingId.toString() },
    signal,
  });

export const listEmployerCredits = (employerId: number) =>
  getData<EmployerCredit[]>('billingAdminCredits', {
    pathParams: { employerId: employerId.toString() },
  });

export const grantEmployerCredit = (
  employerId: number,
  data: { amountCents: number; expiresAt: string; notes?: string }
) =>
  postData<EmployerCredit>('billingAdminCredits', {
    pathParams: { employerId: employerId.toString() },
    data,
  });

export const revokeEmployerCredit = (creditId: number) =>
  deleteData('billingAdminCredit', {
    pathParams: { creditId: creditId.toString() },
  });

export const openBillingPortal = async (options?: {
  returnPath?: string;
  mode?: BillingPortalMode;
}) => {
  const returnPath = options?.returnPath ?? `${window.location.pathname}${window.location.search}`;
  const mode = options?.mode ?? 'replace';
  const session = await createBillingPortalSession(returnPath, mode);
  window.location.assign(session.url);
};
